// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"c3b7b9f0","207":"752f95fa","532":"dfb6acbb","600":"c71cbad1","732":"afb73b47","744":"141e394c"}[chunkId] + ".chunk.js";
};